import { getImageUrl } from "Common/utils/ImageDomain";
import Button from "../../Common/Components/ButtonComponent/Button";
import React from "react";
import DescriptionHtmlCode from "../../Common/Components/HtmlCode/DescriptionHtmlCode";
import ShowOnlyText from "../../Common/Components/HtmlCode/ShowOnlyText";

function CollectionSegmentCard({
  award,
  handleRemoveIcon,
  index,
  errors,
  removeSegment,
  isEditable,
  toggle,
  setIndex,
  setEventData,
  handleSegmentInputChange,
  pageId,
  segmentId,
}) {
  return (
    <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
      <div>
        <div className="flex my-4">
          {award?.icon ? (
            <div className="flex items-center">
              <div className="relative w-40 h-40">
                <img
                  data-dz-thumbnail
                  className="rounded border-[gray] border"
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                  }}
                  src={getImageUrl(award?.icon)}
                  alt={"img"}
                />
                <span
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "6px",
                    fontSize: "22px",
                    cursor: "pointer",
                  }}
                  onClick={
                    isEditable
                      ? () => {
                          handleRemoveIcon(index);
                        }
                      : null
                  }
                >
                  ×
                </span>
              </div>
              <div className="h-3 ml-3">
                <button
                  disabled={!isEditable}
                  onClick={
                    isEditable
                      ? () => {
                          toggle();
                          setIndex(index + 1);
                          setEventData(undefined);
                        }
                      : null
                  }
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  Change
                </button>
              </div>
            </div>
          ) : (
            <button
              onClick={
                isEditable
                  ? () => {
                      toggle();
                      setIndex(index + 1);
                      setEventData(undefined);
                    }
                  : null
              }
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              Add imageUrl
            </button>
          )}
        </div>
        {errors.segments[index]?.icon && (
          <p className="text-sm text-red-500">{errors.segments[index].icon}</p>
        )}
      </div>

      <label className="inline-block mb-2 text-base font-medium">
        Description
      </label>
      <ShowOnlyText content={award?.description} setContent={""} />

      {isEditable ? (
        <DescriptionHtmlCode
          content={award.description}
          setContent={(e) => handleSegmentInputChange(index, "description", e)}
        />
      ) : null}
      {errors.segments[index]?.description && (
        <p className="text-sm text-red-500">
          {errors.segments[index].description}
        </p>
      )}

      <label className="inline-block mb-2 text-base font-medium">
        Header Text
      </label>
      <input
        disabled={!isEditable}
        type="text"
        value={award.header_text}
        onChange={(e) =>
          handleSegmentInputChange(index, "header_text", e.target.value)
        }
        className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
        placeholder="Enter header text"
      />
      {errors.segments[index]?.header_text && (
        <p className="text-sm text-red-500">
          {errors.segments[index].header_text}
        </p>
      )}
      {/* Remove Segment Button */}
      <div className="flex justify-end mt-2">
        {/* <button
          disabled={!isEditable}
          onClick={() => removeSegment(index)}
          className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
        >
          Remove
        </button> */}
        <Button
          btnText="Remove"
          onClick={() => removeSegment(index)}
          id={segmentId}
          pageId={pageId}
          disabled={!isEditable}
          className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
        />
      </div>
    </div>
  );
}

export default CollectionSegmentCard;
